import { $DomainEntityReflection } from '@salsita-ai/platform-project-sdk/domain';
const getCompoundKey = (keys)=>{
    return Object.values(keys).join('_');
};
function generateCombinations(config) {
    const keys = Object.keys(config);
    if (keys.length === 0) {
        return [
            []
        ] // Base case: no keys, return an array with an empty combination
        ;
    }
    const firstKey = keys[0];
    const values = Array.isArray(config[firstKey]) ? config[firstKey] : [
        config[firstKey]
    ];
    // Recursively get combinations for the rest of the keys
    const remainingConfig = {};
    for(let i = 1; i < keys.length; i++){
        remainingConfig[keys[i]] = config[keys[i]];
    }
    const combinationsOfRest = generateCombinations(remainingConfig);
    const allCombinations = [];
    for (const value of values){
        for (const combination of combinationsOfRest){
            allCombinations.push([
                value,
                ...combination
            ]);
        }
    }
    return allCombinations;
}
const reduceDataItems = (data)=>{
    return data.reduce((acc, item)=>{
        const keyCombinations = generateCombinations(item.keys);
        for (const combination of keyCombinations){
            acc[combination.join('_')] = item.values;
        }
        return acc;
    }, {});
};
export const getEnumCombinations = (e, map)=>{
    const initialValue = {};
    return e.values().reduce((acc, enumKey)=>{
        acc[enumKey] = map(enumKey);
        return acc;
    }, initialValue);
};
export class DataBindingBuilder {
    _name;
    _entity;
    _keys;
    _data;
    constructor(_name, // @ts-expect-error we want this for good type inference
    _entity, _keys, _data = {}){
        this._name = _name;
        this._entity = _entity;
        this._keys = _keys;
        this._data = _data;
    }
    static from(name, entity, keys, data = []) {
        return new DataBindingBuilder(name, entity, keys, reduceDataItems(data));
    }
    static fromConstant(dataItem) {
        return new DataBindingBuilder('constant', new $DomainEntityReflection('', []), [], {
            [getCompoundKey({})]: dataItem
        });
    }
    bind(path) {
        return (s)=>{
            const compoundKey = this._keys.map((key)=>s[key]).join('_');
            const value = path ? this._data[compoundKey]?.[path] : this._data[compoundKey];
            if (value === undefined) {
                console.error(`${s.type} - ${this._name} (${compoundKey}), no data found for this data binding key!`, s, this._data);
                throw new Error(`${s.type} - ${this._name} (${compoundKey}), no data found for this data binding key!`);
            }
            return value;
        };
    }
}
export class ExpressionBindingBuilder {
    _name;
    _entity;
    _keys;
    _data;
    constructor(_name, // @ts-expect-error we want this for good type inference
    _entity, _keys, _data = {}){
        this._name = _name;
        this._entity = _entity;
        this._keys = _keys;
        this._data = _data;
    }
    static from(name, entity, keys, data = []) {
        return new ExpressionBindingBuilder(name, entity, keys, reduceDataItems(data));
    }
    bind() {
        return (s)=>{
            const compoundKey = this._keys.map((key)=>s[key]).join('_');
            const value = this._data[compoundKey]?.value;
            if (value === undefined) {
                console.error(`${s.type} - ${this._name} (${compoundKey}), no data found for this data binding key!`, s, this._data);
                throw new Error(`${s.type} - ${this._name} (${compoundKey}), no data found for this data binding key!`);
            }
            return s[value];
        };
    }
}
export class ParentInheritExpressioonBuilder {
    _keys;
    constructor(_keys){
        this._keys = _keys;
    }
    static from(_entity) {
        return new ParentInheritExpressioonBuilder([]);
    }
    inherit(key) {
        return new ParentInheritExpressioonBuilder([
            ...this._keys,
            key
        ]);
    }
    use(key) {
        return new ParentInheritExpressioonBuilder([
            ...this._keys,
            key
        ]);
    }
    bind() {
        return (s)=>{
            return this._keys.reduce((acc, key)=>{
                const value = acc[key];
                if (value === undefined) {
                    throw new Error(`${acc.type} - (${String(key)}), no data found for this data binding key!`);
                }
                return value;
            }, s);
        };
    }
}
export class PartsBindingBuilder {
    _name;
    _entity;
    _keys;
    _data;
    _map;
    constructor(_name, // @ts-expect-error we want this for good type inference
    _entity, _keys, _data = {}, _map){
        this._name = _name;
        this._entity = _entity;
        this._keys = _keys;
        this._data = _data;
        this._map = _map;
    }
    static from(name, entity, keys, map, data = []) {
        return new PartsBindingBuilder(name, entity, keys, reduceDataItems(data), map);
    }
    bind() {
        return (s)=>{
            const compoundKey = this._keys.map((key)=>s[key]).join('_');
            const value = this._data[compoundKey];
            if (value === undefined) {
                console.error(`${s.type} - ${this._name} (${compoundKey}), no data found for this data binding key!`, s, this._data);
                const firstKey = Object.keys(this._data)[0];
                if (!firstKey) {
                    throw new Error(`${s.type} - ${this._name} (${compoundKey}), no data found for this data binding key!`);
                }
                return this._map(this._data[firstKey], s);
            }
            return this._map(value, s);
        };
    }
}

//# sourceMappingURL=data-binding.js.map